<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="() => $router.go(-1)" :disabled="false">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Gestão de Relatório
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card v-if="turma && aluno">
          <v-card-title>Relatório</v-card-title>
          <v-card-text>
            <h4>Turma: {{ turma.descricao }}</h4>
            <h4>Aluno: {{ aluno.nomecompleto }}</h4>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-card-title>Professores (diários)</v-card-title>
          <v-card-text>
            <div v-for="diario in gestao_de_aulas" :key="diario.id">
              Professor(a): {{ diario.professor.nome }} | Disciplina:
              {{ diario.disciplina.descricao }}
            </div>
          </v-card-text>
          <v-spacer></v-spacer>

          <v-card-actions>
            <v-btn class="caption ml-2" @click="show = !show" text
              >Legendas para auxiliar no lançamento do sistema BNCC</v-btn
            >

            <v-spacer></v-spacer>

            <v-btn icon @click="show = !show">
              <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
            </v-btn>
          </v-card-actions>
          <v-expand-transition>
            <div v-show="show">
              <v-divider></v-divider>

              <v-card-text>
                <v-chip v-for="(legenda, i) in legendas" :key="i" class="ma-2" small>
                  <strong>{{ i }}</strong
                  >&nbsp;-&nbsp;{{ legenda }}
                </v-chip>
                <v-divider></v-divider>
                <v-chip v-for="(style, i) in styleClass" :key="i" class="ma-2" small :color="style">
                  <strong>{{ i }}</strong
                  >&nbsp;-&nbsp;lançamento(s)
                </v-chip>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mt-3">
      <template>
        <v-tabs v-model="tab_atual" background-color="primary" dark>
          <v-tab v-for="tab of tabs" :key="tabs.indexOf(tab)">{{ tab.descricao }}</v-tab>
        </v-tabs>

        <v-card-text>
          <v-simple-table class="elevation-1" v-show="tab_atual == 0">
            <template v-slot:default>
              <tbody v-for="(parent, index) in aspecto?.children" :key="index">
                <tr>
                  <td colspan="5" class="text-h6">{{ parent.descricao }}</td>
                </tr>
                <tr v-for="(child, index) in parent?.children" :key="index">
                  <td>
                    {{ child.descricao }}
                  </td>
                  <td v-if="!child.is_outro" class="text-center">
                    <v-switch v-model="selecaoOpcoes" :value="child.id" inset></v-switch>
                  </td>
                  <td v-else>
                    <v-textarea v-model="textoOpcoes[child.id]" color="teal">
                      <template v-slot:label>
                        <div>Outros <small>(opcional)</small></div>
                      </template>
                    </v-textarea>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-simple-table class="elevation-1" v-show="tab_atual == 1">
            <template v-slot:default>
              <tbody v-for="parent of sistemaBNCC" :key="parent.id">
                <tr>
                  <td colspan="5" class="text-h6">{{ parent.descricao }}</td>
                </tr>
                <tr v-for="child in parent.children" :key="child.id" :class="changeColor(child)">
                  <td>
                    <span class="font-weight-medium">
                      {{ child.apelido }}
                    </span>
                    - {{ child.descricao }}
                  </td>
                  <td>
                    <v-select
                      class="mt-4"
                      :items="opcoes"
                      v-model="notas[child.id].nota_b1"
                      label="B1"
                      outlined
                      dense
                    ></v-select>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-col cols="12">
          <v-btn color="success" :loading="promiseCount > 0" block @click="salvarNotas"
            >Enviar Relatório</v-btn
          >
        </v-col>
      </template>
    </v-card>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      legendas: null,
      opcoes: null,
      aspecto: null,
      selecaoOpcoes: [],
      selecaoOpcoesConcluido: [],
      textoOpcoes: [],
      textoOpcoesConcluido: [],
      sistemaBNCC: null,
      notas: null,
      aluno: null,
      matricula: null,
      turma: null,
      gestao_de_aulas: null,
      promiseCount: 0,
      tab_atual: 0,
      resumos: {},
      styleClass: [
        "red lighten-4",
        "yellow accent-1",
        "orange accent-1",
        "lime lighten-3",
        "light-green lighten-1",
      ],
      show: true,
      tabs: [
        {
          id: 0,
          descricao: "Aspecto da Criança",
        },
        {
          id: 1,
          descricao: "Sistema BNCC",
        },
      ],
    };
  },
  async created() {
    await this.loadBasicData();
  },
  watch: {
    textoOpcoes(newText) {
      this.textoOpcoesConcluido = [];
      newText.map((value, index) => {
        this.textoOpcoesConcluido.push({ id: index, value: value || null });
      });
    },
  },
  methods: {
    changeColor(obj) {
      let countClass = 0;
      if (this.notas[obj.id].nota_b1) {
        countClass += 1;
      }
      if (this.notas[obj.id].nota_b2) {
        countClass += 1;
      }
      if (this.notas[obj.id].nota_b3) {
        countClass += 1;
      }
      if (this.notas[obj.id].nota_b4) {
        countClass += 1;
      }
      return this.styleClass[countClass];
    },
    hasAspectosCriancaPreenchidos() {
      if (this.selecaoOpcoes && this.selecaoOpcoes.length > 0) {
        return true;
      }

      const textosPreenchidos = this.textoOpcoesConcluido.filter(
        (item) => item && item.value && item.value.trim() !== ""
      );

      return textosPreenchidos.length > 0;
    },
    hasSistemaBNCCPreenchido() {
      if (!this.notas) return false;
      return Object.values(this.notas).some((nota) => {
        if (!nota) return false;

        return (
          (nota.nota_b1 && nota.nota_b1.trim() !== "") ||
          (nota.nota_b2 && nota.nota_b2.trim() !== "") ||
          (nota.nota_b3 && nota.nota_b3.trim() !== "") ||
          (nota.nota_b4 && nota.nota_b4.trim() !== "")
        );
      });
    },
    preencherOpcoes(aspecto) {
      aspecto.children.forEach((parent) => {
        parent.children.forEach((child) => {
          if (
            child.resposta?.aspectos_id &&
            child.resposta?.matricula_id === parseInt(this.$route.params.matricula_id, 10)
          ) {
            this.selecaoOpcoes.push(child.resposta.aspectos_id);
          }
        });
      });
    },
    preencherTextos(aspecto) {
      aspecto.children.forEach((parent) => {
        parent.children.forEach((child) => {
          if (
            child.resposta?.aspectos_id &&
            child.resposta?.bimestre_1 &&
            child.resposta?.matricula_id === parseInt(this.$route.params.matricula_id, 10)
          ) {
            this.textoOpcoes[child.resposta.aspectos_id] = child.resposta.bimestre_1;
            this.textoOpcoesConcluido[child.resposta.aspectos_id] = {
              id: child.resposta.aspectos_id,
              value: child.resposta.bimestre_1,
            };
          }
        });
      });
    },
    async loadBasicData() {
      try {
        this.$loaderService.open("Carregando dados...");
        const payload = await this.$services.sistemaBNCCService.syncAll(
          parseInt(this.$route.params.matricula_id, 10)
        );
        const aspects_payload = await this.$services.sistemaBNCCService.getAspects(
          parseInt(this.$route.params.matricula_id, 10)
        );
        this.aspecto = aspects_payload.aspecto_crianca;

        this.preencherOpcoes(this.aspecto);
        this.preencherTextos(this.aspecto);

        this.sistemaBNCC = payload.sistema.sistema_b_n_c_c.children;
        this.legendas = payload.sistema.sistema_b_n_c_c.legenda;
        this.opcoes = Object.keys(payload.sistema.sistema_b_n_c_c.opcoes);
        this.notas = payload.notas;
        this.aluno = payload.matricula.aluno;
        this.matricula = payload.matricula;
        this.turma = payload.matricula.turma;
        this.resumos = { ...payload.resumos, matricula_id: this.matricula.id };
        this.gestao_de_aulas = payload.matricula.turma.gestao_de_aulas;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async salvarNotas() {
      const aspectosPreenchidos = this.hasAspectosCriancaPreenchidos();
      const sistemaBNCCPreenchido = this.hasSistemaBNCCPreenchido();

      if (aspectosPreenchidos && !sistemaBNCCPreenchido) {
        this.$modals.warn({
          title: "Atenção",
          message: "Os campos referentes a Sistema BNCC não foram preenchidos. Deseja Prosseguir?",
          icon: "fa-exclamation-triangle",
          buttons: [
            {
              text: "Cancelar",
              callback: () => {
                this.$modals.close();
              },
              props: {
                color: "grey",
                small: true,
              },
            },
            {
              text: "Prosseguir",
              callback: async () => {
                this.$modals.close();
                await this.executarSalvamento();
              },
              props: {
                color: "primary",
                small: true,
              },
            },
          ],
        });
        return;
      }

      if (!aspectosPreenchidos && sistemaBNCCPreenchido) {
        this.$modals.warn({
          title: "Atenção",
          message:
            "Os campos referentes a Aspectos da criança não foram preenchidos. Deseja Prosseguir?",
          icon: "fa-exclamation-triangle",
          buttons: [
            {
              text: "Cancelar",
              callback: () => {
                this.$modals.close();
              },
              props: {
                color: "grey",
                small: true,
              },
            },
            {
              text: "Prosseguir",
              callback: async () => {
                this.$modals.close();
                await this.executarSalvamento();
              },
              props: {
                color: "primary",
                small: true,
              },
            },
          ],
        });
        return;
      }

      await this.executarSalvamento();
    },
    async executarSalvamento() {
      this.promiseCount += 1;
      try {
        await this.$services.sistemaBNCCService.salvarNotas(
          parseInt(this.$route.params.matricula_id, 10),
          {
            notas: this.notas,
            resumos: this.resumos,
          }
        );
        this.$toast.info("Relatório está sendo salvo..., Por favor aguarde!");
        await this.$services.sistemaBNCCService.salvarAspectos(
          parseInt(this.$route.params.matricula_id, 10),
          {
            opcoes: this.selecaoOpcoes,
            outros: this.textoOpcoesConcluido,
          }
        );
        this.$toast.info("Aspectos foram salvos...");
      } catch (error) {
        this.$handleError(error);
      }
      this.promiseCount -= 1;
      this.$router.back();
    },
  },
};
</script>

<style></style>
